import { QueryFunction, useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import * as SDK from '@replai-platform/sdk';
import * as provider from '../../api/provider';

const getConceptAvgAge = async (requestParams: SDK.GetConceptsAverageAgeRequest) => {
  const res = await provider.getJson<object, SDK.GetConceptsAverageAgeResponse>(
    `${SDK.BASE_URL()}/concepts/averageAge?${SDK.convertRequestToQueryParams(requestParams)}`
  );
  return res;
};

const KEY = 'concept-avg-age';
type Key = typeof KEY;

type Result = SDK.GetConceptsAverageAgeResponse;
type QueryKey = [Key, SDK.GetConceptsAverageAgeRequest];

type QueryOptions = UseQueryOptions<Result, unknown, Result, QueryKey>;
type QueryResult = UseQueryResult<Result>;

const queryFn: QueryFunction<Result, QueryKey> = ({ queryKey: [, requestParams] }) => getConceptAvgAge(requestParams);

// This is exported so we can use useQueries
export function getConceptAvgAgeQueryOptions(
  requestParams: SDK.GetConceptsAverageAgeRequest,
  options?: QueryOptions
): QueryOptions {
  return {
    queryKey: [KEY, requestParams],
    queryFn,
    ...options,
  };
}

export default function useConceptAvgAge(
  requestParams: SDK.GetConceptsAverageAgeRequest,
  options?: QueryOptions
): QueryResult {
  return useQuery(getConceptAvgAgeQueryOptions(requestParams, options));
}
